// extracted by mini-css-extract-plugin
var _1 = "SearchInput_capitalizeMobilePlaceholder__kQrik";
var _2 = "SearchInput_clear__7jUhc";
export { _1 as "capitalizeMobilePlaceholder", _2 as "clear" }
